<div>
    <h3 class="title" translate>Settings.SystemWhiteLabelProvidersSection.Title</h3>
</div>
<div class="p-4 pt-1">
    <form>
        <div class="row">
            <div class="col-6 col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5">
                <input type="text" class="form-control" id="inputSearch" placeholder="{{ 'Settings.SystemWhiteLabelProvidersSection.Search' | translate }}"  (keyup)="applyFilter($event)">
            </div>
            <div class="offset-lg-1 offset-xl-1 offset-xxl-1 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 text-end">
                <button type="button" id="buttonSave" class="btn btn-sm btn-secondary me-1" (click)="addwhitelabelprovider()">
                    <span translate="Settings.SystemWhiteLabelProvidersSection.AddWhiteLabelProvider"></span>
                </button>
            </div>
        </div>

        <app-whiteLabelProvidersList [whitelabelproviders]="whiteLabelProviders" (triggerAction)="TriggerAction($event)" [filter]="filter"></app-whiteLabelProvidersList>
    </form>
</div>